import React from 'react';
import ForOwnersComponent from '../components/ForOwners';

const ForOwners = () => {
  return (
    <>
      <ForOwnersComponent />
    </>
  );
};

export default ForOwners;

